export const flowPayloadWithDefaults = (payload) => {
  const defaults = {
    track_clicks: true,
    track_opens: true,
    schedule: {
      1: { start: '09:00', end: '18:00' },
      2: { start: '09:00', end: '18:00' },
      3: { start: '09:00', end: '18:00' },
      4: { start: '09:00', end: '18:00' },
      5: { start: '09:00', end: '18:00' },
    },
  };

  return { ...defaults, ...payload };
};
